// web.ts
import { WebPlugin } from '@capacitor/core';
export class LiveActivityWeb extends WebPlugin {
    async startActivity(_options) {
        console.warn('LiveActivity: startActivity is only available on iOS.');
    }
    async startSingleActivity(_options) {
        console.warn('LiveActivity: startSingleActivity is only available on iOS.');
    }
    async startOrUpdateActivity(_options) {
        console.warn('LiveActivity: startOrUpdateActivity is only available on iOS.');
    }
    async updateActivity(_options) {
        console.warn('LiveActivity: updateActivity is only available on iOS.');
    }
    async endActivity(_options) {
        console.warn('LiveActivity: endActivity is only available on iOS.');
    }
    async isAvailable() {
        console.warn('LiveActivity: isAvailable is only available on iOS.');
        return false;
    }
    async isRunning(_options) {
        console.warn('LiveActivity: isRunning is only available on iOS.');
        return false;
    }
    async getCurrentActivity() {
        console.warn('LiveActivity: getCurrentActivity is only available on iOS.');
        return undefined;
    }
    async getAllActivities() {
        console.warn('LiveActivity: getAllActivities is only available on iOS.');
        return [];
    }
    async endAllActivities() {
        console.warn('LiveActivity: endAllActivities is only available on iOS.');
    }
    async detectDuplicates() {
        console.warn('LiveActivity: detectDuplicates is only available on iOS.');
        return [];
    }
    async endActivitiesById(_options) {
        console.warn('LiveActivity: endActivitiesById is only available on iOS.');
        return { endedCount: 0 };
    }
}
//# sourceMappingURL=web.js.map